import { render, staticRenderFns } from "./RegistrarPagoManualOVG.vue?vue&type=template&id=69e64ae0&scoped=true&lang=pug"
import script from "./RegistrarPagoManualOVG.vue?vue&type=script&lang=js"
export * from "./RegistrarPagoManualOVG.vue?vue&type=script&lang=js"
import style0 from "./RegistrarPagoManualOVG.vue?vue&type=style&index=0&id=69e64ae0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69e64ae0",
  null
  
)

export default component.exports